import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

const meta = {
	description: 'The NRL Magic Round is coming!',
	image: '/images/blog-magicmay/magicmay.png',
	title: 'Magic May | blueshyft',
	url: 'https://blueshyft.com.au/blogs/magicmay',
};

import '../../css/about.css';

export default class About extends Component {
	render () {

		return (
			<React.Fragment>
				<Helmet
					title={meta.title}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.image },
					]}
				/>

				<section className="about-cryptocurrency">
					<div className="about-cryptocurrency-sub">
						<div className="about-cryptocurrency-image-container">
							<img src="/images/blog-magicmay/magicmay.png" alt="crpyotcurrency" className="about-cryptocurrency-image" />
						</div>
					</div>
				</section>

				<section className="wrapup">
					<div className="block block-crypto">
						<h4>The NRL Magic Round is coming!</h4>
						<p>The NRL Magic Round is fast approaching, beginning on May 14 and finishing May 16. All sixteen teams will be heading up to Brisbane to compete in what is set to be a massive weekend of footy! All games will be held at Suncorp stadium, with all eight games set to be pivotal moments coming into the second half of the season. The headliners of the weekend feature on Sunday when New Zealand Warriors take on Parramatta Eels, as well as a top eight clash between Melbourne Storm and St George Illawarra Dragons.</p>
					</div>

					<div className="block block-crypto">
						<p>State of Origin is fast approaching on June 9, so players from all clubs will be looking to remain hungry this month to impress their respective state coaches. We can say with a high degree of certainty that we are in for an entertaining month of rugby league. Keep a lookout for any special offers from Ladbrokes and Neds!</p>
					</div>

					<div className="block block-crypto">
						<h4>A season-defining round</h4>
						<p>The AFL season is fast becoming one for the ages. With Melbourne winning eight out of eight and four teams with twenty points, the season has begun in a very exciting manner. The weekend of the fourteenth of May, second and third (Port Adelaide and Western Bulldogs) play each other to continue the tight battle at the top. If The Bulldogs win, the two at the top will be pulling ahead rapidly, with Melbourne already far ahead of the other teams..</p>
					</div>

					<div className="block block-crypto">
						<p>A weekend packed with rugby league and Australian rules fixtures; there is bound to be some winners and losers. This weekend will prove to be crucial in deciding the top eight for each code. These mouth-watering fixtures are sure to be accompanied by special offers from Ladbrokes and Neds; make sure you check them out on their respective apps. To make the most of these offers, customers can visit their closest blueshyft store to deposit funds into their wagering accounts.</p>
					</div>
				</section>

			</React.Fragment>
		);
	}
};



// WEBPACK FOOTER //
// ./client/scenes/blog-20210512/index.js